import { actionLabel, areaLabel, isCanonicalAction } from './acervoHelpers'

export default function AcervoFields({ fields, onChange, areas, acoesCanonicas = [], catalogLoading = false, disabled, id = 'acervo' }) {
  const update = (field) => (event) => onChange({ ...fields, [field]: event.target.value })
  const legacyAction = fields.acao && !isCanonicalAction(fields.acao, acoesCanonicas)
  return (
    <fieldset className="acervo-fields" disabled={disabled}>
      <label className="acervo-field acervo-field-wide">Título da peça *
        <input value={fields.titulo} onChange={update('titulo')} maxLength={240} required placeholder="Ex.: Manifestação sobre os documentos apresentados" />
      </label>
      <label className="acervo-field">Área jurídica *
        <select value={fields.area} onChange={update('area')} required>
          <option value="">Selecione a área</option>
          {areas.map((area) => <option key={area.key} value={area.key}>{area.label}</option>)}
        </select>
      </label>
      <label className="acervo-field">Ação do motor *
        <select id={`${id}-acoes`} value={fields.acao} onChange={update('acao')} required disabled={catalogLoading}>
          <option value="">{catalogLoading ? 'Carregando ações…' : 'Selecione a ação'}</option>
          {legacyAction && <option value={fields.acao} disabled>{actionLabel(fields.acao)} · vínculo anterior</option>}
          {acoesCanonicas.map((acao) => <option key={acao.codigo} value={acao.codigo}>{acao.nome}</option>)}
        </select>
        <small>{legacyAction && !catalogLoading
          ? 'Esta ação não está ativa no motor. Selecione uma ação configurada antes de reclassificar ou indexar.'
          : 'Ações ativas cadastradas nas configurações do motor de prazos.'}</small>
      </label>
      <div className="acervo-classification acervo-field-wide">
        <i className="fas fa-folder-tree" aria-hidden="true" />
        <strong>{fields.area ? areaLabel(areas, fields.area) : 'Escolha a área'}</strong><span>/</span>
        <strong>{fields.acao.trim() ? actionLabel(fields.acao, acoesCanonicas) : 'Selecione a ação'}</strong>
      </div>
      <label className="acervo-field acervo-field-wide">Observações
        <textarea value={fields.observacoes} onChange={update('observacoes')} rows={3} maxLength={2000} placeholder="Quando esta peça pode servir de referência?" />
      </label>
    </fieldset>
  )
}
